import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Styles from "./styles.module.scss";
import SearchBar from "@Atom/SearchBar";
import Icon from "@Atom/Icon";
import Images from "@Theme/Images";
import CustomTable from "@Molecule/CustomTable";
import { Tooltip } from "@mui/material";
import ModalWrapper from "@Atom/ModalWrapper";
import JobActionsModal from "./JobActionsModal";
import { useLocation, useNavigate } from "react-router-dom";
import useQuery from "@Hooks/useQuery";
import { useDebounce } from "@Hooks/useDebounce";
import moment from "moment";
// import useWindowSize from "@Hooks/useWindowSize";
import Toast from "@Atom/Toast";

export default function JobList({ initialData }) {
  const query = useQuery();

  const [searchName, setSearchName] = useState(query?.get("s") || "");
  const [limit, setLimit] = useState(+query?.get("l") || 10);
  const [pages, setPages] = useState(+query?.get("p") || 1);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const debounceSearch = useDebounce(searchName, 300);

  const [trigger, setTrigger] = useState(query?.get("tr") || "");

  const [success, setSuccess] = useState("");

  useEffect(() => {
    navigate(
      `${pathname}?l=${limit || 10}&p=${pages || 1}&s=${
        debounceSearch || ""
      }&tr=${trigger || ""}`
    );
  }, [navigate, pathname, limit, pages, debounceSearch, trigger]);

  const [dropdownAction, setDropdownAction] = useState("");

  const [openAction, setOpenAction] = useState(null);

  const ref = useRef(null);

  const closeOpenMenus = useCallback(
    (e) => {
      if (ref.current && dropdownAction && !ref.current.contains(e.target)) {
        setDropdownAction(false);
      }
    },
    [ref, dropdownAction]
  );

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
  }, [ref, closeOpenMenus]);

  const templateData = useMemo(() => {
    return {
      data:
        initialData?.response?.data?.length > 0
          ? initialData?.response?.data?.map((el) => {
              return {
                isBackground: true,
                id: el?._id,
                name: el?.title,
                createtAt: el?.createdAt
                  ? moment(new Date(el?.createdAt)).format("DD MMMM YYYY")
                  : "-",
                totalCandidate: el?.candidateCount,
                expiredDate: el?.expiredDate
                  ? Math.max(
                      0,
                      moment(new Date(el?.expiredDate))?.diff(moment(), "days")
                    )
                  : "0",
                status: el?.status
                  ? el?.status?.toLowerCase() === "publish"
                    ? "Aktif"
                    : el?.status?.toLowerCase() === "draft"
                    ? "Draft"
                    : el?.status?.toLowerCase() === "unpublish"
                    ? "Ditutup"
                    : "Menunggu Verifikasi"
                  : null,
              };
            })
          : [],
      colums: [
        {
          name: "name",
          label: "Nama Posisi",
          renderData: (row) => (
            <div
              className={`${Styles.nameBoxRow} ${
                row?.status === "Ditutup" && Styles.grey
              }`}
            >
              <span>{row?.name || "-"}</span>
              <span>Diunggah pada {row?.createtAt}</span>
            </div>
          ),
        },
        {
          name: "totalCandidate",
          label: "Jumlah Pelamar",
          renderData: (row) => (
            <div>
              <span
                style={{
                  color: row?.status === "Ditutup" ? "#919eb0" : "",
                }}
              >
                {row?.totalCandidate || "0"} Kandidat
              </span>
            </div>
          ),
        },
        {
          name: "expiredDate",
          label: "Masa Lowongan Kerja Tampil",
          renderData: (row) => (
            <div>
              <span
                style={{
                  color: row?.status === "Ditutup" ? "#919eb0" : "",
                }}
              >
                {row?.expiredDate || "-"} Hari
              </span>
            </div>
          ),
        },
        {
          name: "status",
          label: "Status",
          renderData: (row) => (
            <div className={Styles.statusRow}>
              <span
                className={`${row?.status === "Aktif" && Styles.active} ${
                  row?.status === "Draft" && Styles.draft
                } ${row?.status === "Ditutup" && Styles.closed}`}
              >
                {row?.status || "-"}
              </span>
            </div>
          ),
        },
        {
          name: "action",
          label: "Action",
          renderData: (row) => (
            <div className={Styles.actionBox}>
              <div
                className={Styles.preview}
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`/business/preview-loker/${row?.id}`);
                }}
              >
                <span>Preview</span> Loker
              </div>
              <Tooltip title="Edit">
                <div
                  className={Styles.edit}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`${pathname}/create?id=${row?.id}`);
                  }}
                >
                  <Icon icon={"edit-v2"} size={20} />
                </div>
              </Tooltip>

              <div className={Styles.listOtherActionBox}>
                <div
                  className={Styles.listOtherAction}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownAction(row?.id);
                  }}
                >
                  <Icon icon={"three-dots-v2"} size={20} />
                </div>

                {dropdownAction === row?.id && (
                  <div className={Styles.dropdown} ref={ref}>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard
                          .writeText(
                            `https://kerja365.id/job-seeker/${row?.id}`
                          )
                          .then(() => {
                            setSuccess("Link berhasil disalin");
                          })
                          .catch((error) => {
                            // Tangani error jika copy ke clipboard gagal
                            console.error(
                              "Gagal menyalin ke clipboard:",
                              error
                            );
                          });
                      }}
                    >
                      Salin link lowongan
                    </span>

                    {row?.status === "Ditutup" && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenAction({
                            type: "Hapus Loker",
                            data: row,
                          });
                        }}
                      >
                        Hapus lowongan pekerjaan
                      </span>
                    )}

                    {row?.status !== "Ditutup" && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenAction({
                            type: "Tutup Loker",
                            data: row,
                          });
                        }}
                      >
                        Tutup lowongan pekerjaan
                      </span>
                    )}

                    {/* <span
                      onClick={() => {
                        setOpenAction({
                          type: "Perpanjang",
                          data: row,
                        });
                      }}
                    >
                      Perpanjang Masa Aktif
                    </span> */}
                  </div>
                )}
              </div>
            </div>
          ),
        },
      ],
    };
  }, [dropdownAction, ref, initialData, navigate, pathname]);

  useEffect(() => {
    const previousPage = pages;
    if (
      +initialData?.response?.totalData === 1 ||
      +initialData?.response?.totalData === 0
    ) {
      setPages(1);
    } else {
      const validPage = Math.max(
        1,
        Math.min(previousPage, +initialData?.response?.totalPage)
      );
      setPages(validPage);
    }
  }, [pages, initialData]);

  useEffect(() => {
    if (openAction) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [openAction]);

  // console.log(initialData?.response?.totalData);

  useEffect(() => {
    setTimeout(() => {
      if (success) setSuccess("");
    }, 2000);
  }, [success]);

  return (
    <div className={Styles.container}>
      <div>
        <div className={Styles.header}>
          <div className={Styles.leftHeader}>
            <span>Daftar Loker</span>
          </div>

          {initialData?.response?.data?.length === 0 &&
          initialData?.response?.staticCount === 0 ? null : (
            <div className={Styles.rightHeader}>
              <div className={Styles.searchBar}>
                <SearchBar
                  placeholder={"Cari nama posisi"}
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  type={"none"}
                  backgroundColorIcon="#fff"
                />
              </div>

              <div className={Styles.button}>
                <button
                  onClick={() => {
                    navigate(`${pathname}/create`);
                  }}
                >
                  <Icon icon={"briefcase-v2"} color={"#FFFFFF"} size={16} />
                  Unggah Loker
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={Styles.content}>
          {initialData?.response?.data?.length === 0 &&
          initialData?.response?.staticCount === 0 ? (
            <div className={Styles.emptyBox}>
              <img src={Images.EMPTY_LOKER} alt="" />
              <span className={Styles.H1}>
                Unggah Lowongan Pekerjaan dan Temukan Talenta Terbaik
              </span>
              <span className={Styles.span}>
                satu langkah lagi agar bisa mendapatkan kandidat terbaik untuk
                perushaaanmu
              </span>

              <button
                onClick={() => {
                  navigate(`${pathname}/create`);
                }}
              >
                <Icon icon={"briefcase-v2"} color={"#FFFFFF"} size={16} />
                Unggah Loker
              </button>
            </div>
          ) : (
            <div className={Styles.table}>
              <CustomTable
                onClickRow={(row) => {
                  navigate(`${pathname}/${row?.id}`);
                }}
                data={templateData?.data || []}
                columns={templateData?.colums}
                value={+limit}
                setValue={setLimit}
                selectedPage={+pages}
                setSelectedPage={setPages}
                totalPage={initialData?.response?.totalPage || 1}
                isV2
                // noContainerBorder
                totalData={initialData?.response?.totalData || 0}
                withNumbering
                bgColorPagination="#ededed"
                minHeight="440px"
                isDashBoardBusiness
                noStickyPagination
                labelTotal="Job Posting"
                isLoadingSkeleton={
                  query?.get("s") !== searchName ||
                  +query?.get("p") !== +pages ||
                  +query?.get("l") !== +limit ||
                  +query?.get("tr") !== +trigger
                }
              />
            </div>
          )}
        </div>

        <Toast isSent={success} label={success} />
      </div>

      {openAction && (
        <ModalWrapper
          isLandingPage
          show={openAction}
          handleClose={() => {
            setOpenAction(null);
          }}
        >
          <JobActionsModal
            handleClose={() => {
              setOpenAction(null);
            }}
            data={openAction}
            setTrigger={setTrigger}
            setSuccess={setSuccess}
          />
        </ModalWrapper>
      )}
    </div>
  );
}
